import React from "react";

import { Tooltip as MuiTooltip, TooltipProps } from "@mui/material";

type PropTypes = TooltipProps & { divClassName?: string };

export const Tooltip = React.forwardRef<HTMLElement, PropTypes>(
  ({ divClassName, children, ...props }, ref) => {
    return (
      <MuiTooltip arrow ref={ref} {...props}>
        <div className={divClassName}>{children}</div>
      </MuiTooltip>
    );
  },
);

Tooltip.displayName = "Tooltip";
